import { __awaiter } from "tslib";
import { trackComscorePageView } from '../bundle/comscore';
import { trackSPPageView, trackSPUIInteractionEvent } from './snowplow';
import { trackUtagPageView, trackUtagEvent } from './tealium';
export var Comscore1PIdentifierType;
(function (Comscore1PIdentifierType) {
    Comscore1PIdentifierType["LOGGED_IN_ID"] = "li";
    Comscore1PIdentifierType["LOGGED_OUT_ID"] = "lo";
    Comscore1PIdentifierType["OPEN_ID"] = "o";
    Comscore1PIdentifierType["COOKIE"] = "c";
})(Comscore1PIdentifierType || (Comscore1PIdentifierType = {}));
export var ConsentLegalBasis;
(function (ConsentLegalBasis) {
    // noinspection JSUnusedGlobalSymbols
    ConsentLegalBasis[ConsentLegalBasis["CONSENT"] = 0] = "CONSENT";
    ConsentLegalBasis[ConsentLegalBasis["LEGIMIATE_INTEREST"] = 1] = "LEGIMIATE_INTEREST";
    ConsentLegalBasis[ConsentLegalBasis["NOT_ALLOWED"] = 2] = "NOT_ALLOWED";
})(ConsentLegalBasis || (ConsentLegalBasis = {}));
export var TrackingCategory;
(function (TrackingCategory) {
    TrackingCategory["AUTO"] = "tracking-auto-link";
    TrackingCategory["HEADER"] = "tracking-header-link";
    TrackingCategory["FOOTER"] = "tracking-footer-link";
    TrackingCategory["NAVIGATION"] = "tracking-navigation-link";
    TrackingCategory["STANDARD"] = "tracking-standard-link";
    TrackingCategory["FOCUS"] = "tracking-focus-link";
    TrackingCategory["INPUTCHANGE"] = "tracking-input-change-link";
    TrackingCategory["LEADS"] = "tracking-leads-link";
    TrackingCategory["VIDEO"] = "tracking-video-link";
    TrackingCategory["MOTORINGPRODUCTS"] = "tracking-motoring-products-link";
    TrackingCategory["MYATPRODUCTS"] = "tracking-my-at-products-link";
    TrackingCategory["DELEGATE"] = "delegate-to-onClick";
})(TrackingCategory || (TrackingCategory = {}));
export var TrackingAction;
(function (TrackingAction) {
    TrackingAction["CLICK"] = "click";
    TrackingAction["SUBMIT"] = "submit";
    TrackingAction["VIEW"] = "view";
    TrackingAction["PERCENTAGE"] = "percentage";
    TrackingAction["KEY_PRESS"] = "key-press";
    TrackingAction["SWIPE"] = "swipe";
    TrackingAction["DD_MENU_CHANGE"] = "dropdown-menu-change";
    TrackingAction["INPUT_CHANGE"] = "input-change";
    TrackingAction["INPUT_FIELD_FOCUS"] = "input-field-focus";
    TrackingAction["PLAY"] = "play";
    TrackingAction["CUSTOM"] = "custom";
})(TrackingAction || (TrackingAction = {}));
const isUtagReady = () => {
    return new Promise((resolve, reject) => {
        var _a, _b;
        if (((_b = (_a = window === null || window === void 0 ? void 0 : window.utag) === null || _a === void 0 ? void 0 : _a.handler) === null || _b === void 0 ? void 0 : _b.iflag) === 1) {
            resolve(window.utag);
        }
        else {
            let count = 0;
            const intervalId = setInterval(() => {
                var _a, _b;
                count = count + 1;
                if (((_b = (_a = window === null || window === void 0 ? void 0 : window.utag) === null || _a === void 0 ? void 0 : _a.handler) === null || _b === void 0 ? void 0 : _b.iflag) === 1) {
                    clearInterval(intervalId);
                    resolve(window.utag);
                }
                else if (count > 50) {
                    clearInterval(intervalId);
                    reject(new Error('Unable to load utag'));
                }
            }, 200);
        }
    });
};
export function trackUtagPageWhenReady(pageTrackingData) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!pageTrackingData['noTealium']) {
            try {
                const utag = yield isUtagReady();
                trackUtagPageView(pageTrackingData, utag);
            }
            catch (err) {
                if (err instanceof Error) {
                    console.error(err.message);
                }
            }
        }
    });
}
export function trackUtagEventWhenReady(eventTrackingData) {
    return __awaiter(this, void 0, void 0, function* () {
        if (!eventTrackingData['noTealium']) {
            try {
                const utag = yield isUtagReady();
                trackUtagEvent(eventTrackingData, utag);
            }
            catch (err) {
                if (err instanceof Error) {
                    console.error(err.message);
                }
            }
        }
    });
}
export { trackComscorePageView };
/**
 *   @deprecated
 *   `@at/sauron-tracking` has been superseded by `@at/track-react` or `@at/track-core`. Please use firePageViewEvent with useTrackContext() instead.
 *   If your app hasn't been migrated, please see the following migration guide:
 *   https://autotrader.atlassian.net/wiki/spaces/UA/pages/3834020050/React+SPA+Tracking+Migration+-+a+Step+by+Step+Guide
 */
export const trackPageView = (pageTrackingData, disableSnowplowTrack) => __awaiter(void 0, void 0, void 0, function* () {
    trackComscorePageView();
    !disableSnowplowTrack && trackSPPageView(pageTrackingData);
    yield trackUtagPageWhenReady(pageTrackingData);
});
/**
 *   @deprecated
 *   `@at/sauron-tracking` has been superseded by `@at/track-react` or `@at/track-core`. Please use fireEvent or fireUIInteractionEvent with useTrackContext() instead.
 *   If your app hasn't been migrated, please see the following migration guide:
 *   https://autotrader.atlassian.net/wiki/spaces/UA/pages/3834020050/React+SPA+Tracking+Migration+-+a+Step+by+Step+Guide
 */
export const trackEvent = (eventTrackingData, disableSnowplowTrack) => __awaiter(void 0, void 0, void 0, function* () {
    !disableSnowplowTrack && trackSPUIInteractionEvent(eventTrackingData);
    yield trackUtagEventWhenReady(eventTrackingData);
});
